import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import ImageAndContent from 'src/app/molecules/ImageAndContent/ImageAndContent';
import { IStaticContentfulImages } from 'src/types/contentful';
import CheckItemTextListWithActions from 'src/app/molecules/CheckItemTextList/CheckItemTextListWithActions';

const BrandedAppImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      featuredImage: contentfulAsset(contentful_id: { eq: "6HfDOwwjKeohK1viixKJlj" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1300)
      }
    }
  `);

  return (
    <ImageAndContent
      image={{
        imageProps: {
          image: images.featuredImage.gatsbyImageData,
          alt: 'Branded App',
        },
        maxWidth: 980,
        radius: 'radius-2xl',
      }}
      contentPosition='left'
      content={
        <Stack
          padding='spacing-none'
          direction='column'
          gap='spacing-4xl'
        >
          <HeadingAndSupportingText
            gap='spacing-3xl'
            heading={{
              type: 'heading',
              text: 'Join the 90%+ club',
              size: '2xl',
              fontWeight: 'font-weight-semibold',
            }}
            subHeading={{
              text: 'Mighty Pro',
              size: 'xl',
              type: 'paragraph',
              color: 'text-brand-secondary',
              fontWeight: 'font-weight-semibold',
            }}
            subHeadingGap='spacing-lg'
            supportingText={{
              type: 'paragraph',
              text: 'Your own branded apps and our expertise can turn stretch goals into sure things.',
              size: 'xl',
              color: 'text-tertiary',
            }}
          />
          <CheckItemTextListWithActions
            direction='column'
            justify='flex-start'
            align='flex-start'
            checkItemTextListProps={{
              checkItems: [
                '100% active members for a relationship coach',
                '91% retention for a paranormal membership',
                '272% new member growth for a language school',
              ],
              checkItemProps: {
                size: 'lg',
                type: 'default',
                color: 'primary',
              },
            }}
            actions={
              <Stack>
                <Button
                  variant='primary'
                  size='xl'
                  href='/pro'
                >
                  Learn More
                </Button>
              </Stack>
            }
          />
        </Stack>
      }
    />
  );
};

export default BrandedAppImageAndContent;
